<template>
<div class="chapter">
<div class="inner_page">
<p class="GillSans-Bold2" style="text-align:center; margin-bottom: -1em;">To the gang at the Creative Bloc,</p>
<p class="GillSans-Bold2" style="text-align:center"> creating creative stuff since 1999.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// VCS_06.vue?2e71dac0